module.exports = {
  profile: "个人资料",
  myAccount: "我的账户",
  myInvoice: "我的发票",
  myCoupon: "我的优惠券",
  partner: "合伙人"
}


// WEBPACK FOOTER //
// ./src/pages/home/i18n/locale.zh-cn.js